const $ = require('jquery');
$.noConflict();
$.DataTable = require('datatables.net');
import WithSystem from './../service/WithSystem';
class TblCourseReport extends React.Component {
  constructor(props) {
    super(props);
    this.tablerender = null;
    
  }
  componentDidMount() {
    this.overallreportrender();
  }
  contentColumnDisplay = () => {
    let contentVisibeObject = this.props.filters.contentDisplay;
    if (Object.keys(contentVisibeObject).length) {
      for (const [key, value] of Object.entries(contentVisibeObject)) {
        this.tablerender.column(key).visible(value);
      }
    }
  }
  overallreportrender = () => {
    this.tablerender = $(this.refs.main).DataTable({
      "lengthMenu": [window.showlimit],
      "lengthChange": false,
      "bFilter": false,
      "stateSave": false,
      "scrollX": true,
        "ordering": true,
      "columnDefs": [
        { className: "center-align", targets: [5,6,7,8,9] },
      ],
      "order": [],
      "processing": true,
      "serverSide": true,
      ajax: {
        type: "POST",
        data: { 'filters': this.props.queryFilter,'course_id':this.props.CourseId },
        beforeSend: function () {
          $("#progress-filter-loading").addClass("show");
        },
        url: admin_url + 'Archive_consolidate_report/course_overall_report'+__setSsAuthUrl,
        "dataSrc": function (response) {
          $("#progress-filter-loading").removeClass("show");
          $('#Tlearners').html(response.totalLeaners);
          $('#Tcompleted').html(response.totalCompleted);
          $('#Tcertifications').html(response.totalCertificates);
          return response.aaData;
        },
      },
      'columns': [
        {
          data: "cs_user_name",
          "mRender": function (data, type, row) {
            var strName = row.csa_cs_user_name;
            var strUsername  = strName;
            if (queryFilter["searchkey"] && strName != null){
              var searchName    = queryFilter["searchkey"];
              var tmpstrName    = strName.toUpperCase();
              var tmpsearchName = searchName.toUpperCase();
              var startTag      = '<mark>';
              var endTag        = '</mark>';
              const startPos    = tmpstrName.indexOf(tmpsearchName);
            if (startPos !== -1) {
              const endPos      = startPos + searchName.length - 1;
              var strOutOne     = [strName.slice(0, startPos), startTag, strName.slice(startPos)].join('');
              var strUsername   = [strOutOne.slice(0, endPos + 7), endTag, strOutOne.slice(endPos + 7)].join('');
            } 
            }
            
            return `<a href="${admin_url}Archive_consolidate_report${__setSsAuthUrl}#/learner_report/${row.csa_cs_user_id}/${row.csa_cs_course_id}">${strUsername}</a>`;
          }
        },
        {
          "mRender": function (data, type, row) {
            var strName          = row.csa_cs_user_email;
            var strUseremail     = strName;
            if (queryFilter["searchkey"] && strName != null) {
              var searchName     = queryFilter["searchkey"];
              var tmpstrName     = strName.toUpperCase();
              var tmpsearchName  = searchName.toUpperCase();
              var startTag       = '<mark>';
              var endTag         = '</mark>';
              const startPose    = tmpstrName.indexOf(tmpsearchName);
              if (startPose !== -1) {
                const endPose    = startPose + searchName.length - 1;
                var strOutOne    = [strName.slice(0, startPose), startTag, strName.slice(startPose)].join('');
                var strUseremail = [strOutOne.slice(0, endPose + 7), endTag, strOutOne.slice(endPose + 7)].join('');
              }
            }
            return `${strUseremail}`;
          }
        },
        {
          "mRender": function (data, type, row) {
            let institueCode = '-';
            if(row.csa_us_institute_code != null){
              institueCode = `${row.csa_us_institute_code}`;
            }
            return institueCode;
          }
        },
        {
          data: "cs_course_tittle",
          "mRender": function (data, type, row) {
            let csTitle = '-';
            if( row.csa_cs_course_tittle != null){

              csTitle =  `${row.csa_cs_course_tittle}`;
            }
            return csTitle;
          }
        },
        {
          data: "cs_percentage",
          "mRender": function (data, type, row) {
            var csa_cs_percentage = row.csa_cs_percentage;
            var percentageColour = '#ff6466';
            if (csa_cs_percentage <= 20){
              percentageColour = '#ff6466';
            } else if (csa_cs_percentage >= 21 && csa_cs_percentage <= 40) {
              percentageColour = '#ff929E';
            } else if (csa_cs_percentage >= 41 && csa_cs_percentage <= 60) {
              percentageColour = '#fcde88';
            } else if (csa_cs_percentage >= 61 && csa_cs_percentage <= 80) {
              percentageColour = '#61dea9';
            } else if (csa_cs_percentage >= 81 && csa_cs_percentage <= 100) {
              percentageColour = '#4ebe6d';

            } 
            return `<div class="d-flex w-100 align-center">
            <div class="leaner-progress-bar">
              <div class="leaner-progress-percent" percent="${row.csa_cs_percentage}%" 
              style="background-color: ${percentageColour}; width: ${row.csa_cs_percentage}%;"></div>
            </div>
            <span>${row.csa_cs_percentage}%</span>
          </div>`;
          }
        },
        {
          data: "cs_subscription_date",
          "mRender": function (data, type, row) {
            var formateed_date = formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.csa_cs_subscription_date)));
            return `${formateed_date}`;
          }
        },
        {
          data: "cs_course_complete_date",
          "mRender": function (data, type, row) {
            if ((parseInt(row.csa_cs_completion_registered) == '1') || (parseInt(row.csa_cs_percentage) == '100')){
              var formateed_date = '-';
              if(row.csa_cs_course_complete_date != null && row.csa_cs_course_complete_date != '0000-00-00 00:00:00'){
                formateed_date =  formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.csa_cs_course_complete_date)));
              }
              else if( row.csa_cs_percentage_updated_date != null && row.csa_cs_percentage_updated_date != '0000-00-00 00:00:00') {
                formateed_date = formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.csa_cs_percentage_updated_date)));
              }
              return `${formateed_date}`;
            }else{
              return `-`;
            }
            
          }
        },
        {
          data: " CAST(`cs_total_duration` AS SIGNED)",
          "mRender": function (data, type, row) {
            return `${((typeof row.csa_cs_total_duration != null)) ? secondsToHms(row.csa_cs_total_duration) : '-'}`;
          }
        },
        {
          "mRender": function (data, type, row) {
            var gradeTag = '-';
            if (row.csa_cs_manual_grade != null){
              gradeTag = row.csa_cs_manual_grade;
            } else if (row.csa_cs_auto_grade != null) {
              gradeTag = row.csa_cs_auto_grade;
            }
            return gradeTag;
          }
        },
         {
          "mRender": function (data, type, row) {

            var gradeTag = '-';
            if (row.csa_cs_marks_obtained != null){
              gradeTag = row.csa_cs_marks_obtained;
            } 
            return gradeTag;
          }
        },
        {
          "mRender": function (data, type, row) {
            if (row.csa_cs_download_certificate == '1') {
              return `<div class="release-icon leaner-tick-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path id="Icon_ionic-md-checkmark-circle" data-name="Icon ionic-md-checkmark-circle" d="M9.313,1.313a8,8,0,1,0,8,8A8.024,8.024,0,0,0,9.313,1.313ZM7.67,13.578l-4.1-4.1,1.15-1.15,2.954,2.954,6.235-6.235,1.15,1.15Z" transform="translate(-1.313 -1.313)" fill="#4ebe6d"></path>
          </svg>
          </div>`;
            } else {
              return `<div class="release-icon leaner-tick-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M9.312,1.313a8,8,0,1,0,8,8A7.972,7.972,0,0,0,9.312,1.313Zm4,10.88-1.12,1.12-2.88-2.88-2.88,2.88-1.12-1.12,2.88-2.88-2.88-2.88,1.12-1.12,2.88,2.88,2.88-2.88,1.12,1.12-2.88,2.88Z" transform="translate(-1.313 -1.313)" fill="#ff6466"></path>
            </svg>
            </div>`;
            }
          }
        },
      ],
      "language": {
        "emptyTable": displayno 
      },
      "drawCallback": function (settings) {
      },
    });
    this.contentColumnDisplay();
  }
  componentDidUpdate(prevProps) {
    if ((this.props.queryFilter.selectedCourse !== prevProps.filters.selectedCourse) || (this.props.queryFilter.startdate !== prevProps.filters.startdate) || (this.props.queryFilter.searchkey !== prevProps.queryFilter.searchkey) || (this.props.queryFilter.comstartdate !== prevProps.queryFilter.comstartdate)) {
      $('#myTable').DataTable().destroy();
      this.overallreportrender();
    } else {
      if (JSON.stringify(this.props.filters.contentDisplay) !== JSON.stringify(prevProps.filters.contentDisplay)) {
        this.contentColumnDisplay();
      }
    }
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <table className="display" id="myTable" ref="main">
          <thead>
            <tr>
              <th>Learner Name</th>
              <th className="no-sort" >Email ID</th>
              <th className="no-sort" >Branch</th>
              <th>Course Name</th>
              <th >Course Progress</th>
              <th >Date of Enrollment</th>
              <th >Completion Date</th>
              <th >Time Spent (hrs)</th>
              <th className="no-sort" >Grade</th>
              <th className="no-sort" >Score</th>
              <th className="no-sort" >Certificate Released</th>
            </tr>
          </thead>
        </table>
      </div>)
  }
}
export default WithSystem(TblCourseReport);
